import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { getDefaultAuthenticatedRoute } from "../../lib/userAccess";
import { Dropdown } from "../ui/dropdown";
import { useToast } from "../ui/toast";

/** Shown only when core turns org_switch on and there is somewhere to switch to. */
export function OrgSwitcher() {
  const { features, organizations, account, dashboardSession, switchOrganization } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();
  const [switching, setSwitching] = useState(false);

  // A customer view is pinned to that customer; core refuses to mint from it anyway.
  if (!features?.org_switch || dashboardSession || (organizations?.length ?? 0) < 2) return null;

  const current = String(account?.organization_id || "");
  const options = organizations.map((org) => ({ value: org.id, label: org.name || org.id }));

  const choose = async (organizationId: string) => {
    if (organizationId === current || switching) return;
    setSwitching(true);
    try {
      const user = await switchOrganization(organizationId);
      // The page we were on may name another org's agent or batch.
      navigate(getDefaultAuthenticatedRoute(user));
    } catch (error) {
      const message = (error as any)?.response?.data?.error?.message;
      toast.danger("Could not switch organization", typeof message === "string" ? message : "Please try again.");
    } finally {
      setSwitching(false);
    }
  };

  return (
    <Dropdown
      ariaLabel="Organization"
      className="w-32 sm:w-44"
      value={current}
      options={options}
      disabled={switching}
      onChange={(id) => { void choose(id); }}
    />
  );
}
